export default __webpack_public_path__ + "static/images/ba86e1fe.png";